// Haversine distance calculation (returns distance in miles)
export function haversineDistance(lat1, lng1, lat2, lng2) {
  const R = 3959; // Earth's radius in miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Calculate competition weight for a listing
export function calculateWeight(listing, hooptiePrice, targetMiles, marketAvgDom) {
  let weight = 1.0; // base weight

  // Price comparison
  const priceDelta = listing.price - hooptiePrice;
  if (priceDelta < -500) {
    // UNDER Hooptie Price
    weight += 0.4;
  } else if (Math.abs(priceDelta) <= 500) {
    // AT Hooptie Price
    weight += 0.2;
  }
  // OVER Hooptie Price => +0.0 (no change)

  // Mileage similarity
  const mileageDiff = Math.abs(listing.miles - targetMiles);
  if (mileageDiff <= 15000) {
    weight += 0.2;
  } else {
    weight -= 0.1;
  }

  // DOM comparison
  if (listing.dom_active <= marketAvgDom + 30) {
    weight += 0.1;
  } else {
    weight -= 0.1;
  }

  // Clamp to [0.2, 2.0]
  return Math.max(0.2, Math.min(2.0, weight));
}

// Normalize lat/lng from API (latitude/longitude) or legacy (lat/lng)
function getListingCoords(listing) {
  const lat = listing.latitude ?? listing.lat;
  const lng = listing.longitude ?? listing.lng;
  return { lat, lng };
}

// Filter listings within radius and calculate weights
export function processListingsForMap(listings, dealerLat, dealerLng, radiusMiles, hooptiePrice, targetMiles, marketAvgDom) {
  const processed = [];
  let missingLocationCount = 0;

  for (const listing of listings) {
    const { lat, lng } = getListingCoords(listing);
    if (lat == null || lng == null) {
      missingLocationCount++;
      continue;
    }

    // Calculate distance
    const distance = haversineDistance(dealerLat, dealerLng, lat, lng);

    // Filter by radius
    if (distance <= radiusMiles) {
      const weight = calculateWeight({ ...listing, lat, lng }, hooptiePrice, targetMiles, marketAvgDom);
      processed.push({
        ...listing,
        lat,
        lng,
        distance,
        weight
      });
    }
  }

  return {
    processed,
    missingLocationCount
  };
}

